import React, { useContext } from 'react';
import { noop } from 'rxjs';
import { AppSnackbarOpts } from '../components/dialog/AppSnackbar';
import {
  BasicDialogOpts,
  InstructionDialogOpts,
} from '../components/dialog/BasicDialog';

type ShowInfoHook = {
  showDialog: (dialogOpts: BasicDialogOpts) => void;
  showSnack: (snackbar: AppSnackbarOpts) => void;
  showInstruction: (dialogOpts: InstructionDialogOpts) => void;
};

const ShowInfoContext = React.createContext<ShowInfoHook>({
  showDialog: noop,
  showSnack: noop,
  showInstruction: noop,
});

type Props = {
  children: React.ReactNode;
  showInfoFunctions: ShowInfoHook;
};

export function ShowInfoProvider({
  children,
  showInfoFunctions,
}: Props): JSX.Element {
  return (
    <ShowInfoContext.Provider value={showInfoFunctions}>
      {children}
    </ShowInfoContext.Provider>
  );
}

export const useShowInfo = (): ShowInfoHook =>
  useContext(ShowInfoContext);
